module.exports = __webpack_public_path__ + "img/IN-white.8ccd4ef9.svg";